import {
    AccordionHeader,
    AccordionItem,
    AccordionBody,
} from 'reactstrap';
import AddExpenses from './AddExpenses';

const Expenses = ({ handleSubmission }) => {
    return (
        <AccordionItem>
            <AccordionHeader
                targetId='2'
                className='less-round-accordion-header'
            >
                <div>Expenses</div>
            </AccordionHeader>
            <AccordionBody accordionId='2'>
                <AddExpenses handleSubmission={handleSubmission} />
            </AccordionBody>
        </AccordionItem>
    );
};

export default Expenses;
